//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** The type of due date. Immediate, ConfiguredDate, GroupAttribute, or DaysAfterJoining. */
export const DueDateType = {
    /** Immediate */
    Immediate: 0,

    /** Configured Date */
    ConfiguredDate: 1,

    /** Group Attribute */
    GroupAttribute: 2,

    /** Days After Joining */
    DaysAfterJoining: 3
} as const;

/** The type of due date. Immediate, ConfiguredDate, GroupAttribute, or DaysAfterJoining. */
export const DueDateTypeDescription: Record<number, string> = {
    0: "Immediate",

    1: "Configured Date",

    2: "Group Attribute",

    3: "Days After Joining"
};

/** The type of due date. Immediate, ConfiguredDate, GroupAttribute, or DaysAfterJoining. */
export type DueDateType = typeof DueDateType[keyof typeof DueDateType];
